import React from 'react';
import { Button, ButtonProps, Spinner } from 'reactstrap';

interface Props extends ButtonProps {
    loading: boolean;
    fixedWidth?: boolean;
}

export class LoadingButton extends React.Component<Props> {
    public render() {
        const { loading, children, fixedWidth, ...rest } = this.props;
        return (
            <Button
                style={!fixedWidth && this.props.loading ? { paddingLeft: '40px' } : {}}
                {...rest}
                disabled={loading}
            >
                {loading ? (
                    <Spinner
                        size="sm"
                        style={{ marginLeft: '-30px', marginRight: '14px' }}
                    />
                ) : null}
                {children}
            </Button>
        );
    }
}